
<div class="headlines">
  <page-header title="Possible Headlines">
    <template #actions>
      <btn
        :disabled="selectedHeadlines.length < 1"
        :loading="submitting"
        loading-text="Submitting"
        @click="submit"
      >
        Submit
      </btn>
    </template>
  </page-header>

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="rowing"
      title="There are no headline sales yet"
    />

    <div v-if="!showEmptyState" class="selected-headlines">
      <div><b>{{ selectedHeadlines.length }}</b> selected</div>
      <div v-for="headline in selectedHeadlines" :key="headline.id">
        {{ headline.cardLabel }} <b>{{ $filters.currency(headline.price, { full: true }) }}</b>
      </div>
    </div>

    <template>
      <section class="headlines-list">
        <div
          v-for="headline in headlines"
          :key="headline.id"
          :class="['headline', { selected: Boolean(selectedHeadlines.find((selectedHeadline) => selectedHeadline.id === headline.id)) }]"
          @click="toggleSelectedHeadline(headline)"
        >
          <align flex class="header" direction="flex-start">
            <a class="link" :href="`/card/${headline.cardId}?showSales=true`" target="_blank">
              <div><b>{{ headline.cardLabel }}</b></div>
            </a>

            <external-link
              v-if="headline.platform === 'eBay'"
              :href="getTerapeakLink(headline)"
            >
              <span>Tera</span>
            </external-link>

            <icon-button
              icon="delete_outline"
              @click.stop.prevent="deletePossibleHeadline(headline.id)"
            />
          </align>

          <align direction="flex-start">
            <div class="images-container">
              <card-image :image-url="headline.image" />
            </div>

            <div class="details-container">
              <a
                v-if="headline.title"
                :href="headline.url"
                class="link title"
                target="_blank"
              >
                <b>{{ headline.title }}</b>
              </a>

              <div>
                <span>Price:</span> <b>{{ $filters.currency(headline.price, { full: true }) }}</b>
              </div>

              <div>
                <span>End Date:</span> <b>{{ $filters.date(headline.date) }}</b>
              </div>

              <div v-if="headline.listingType">
                <span>Type:</span> <b>{{ headline.listingType }}</b>
              </div>

              <div v-if="headline.employee">
                <span>Employee:</span> <b>{{ employeeOptions.find(({ value }) => value === headline.employee)?.label }}</b>
              </div>

              <div v-if="headline.platform">
                <span>Platform:</span> <b>{{ headline.platform }}</b>
              </div>

              <div v-if="headline.allTimeHigh" class="success">
                All-time high
              </div>
            </div>
          </align>
        </div>
      </section>
    </template>
  </div>

  <scroll-top />
</div>
